import api from "./api";
import { FieldPermissions, RolePermissions } from "@/types/Auth.types";
import ProductInformationPermissions from "@/utils/json/FieldPermissions/ProductInformation.json";
import VendorInformationPermissions from "@/utils/json/FieldPermissions/VendorInformation.json";
import VendorAssessmentPermissions from "@/utils/json/FieldPermissions/VendorAssessment.json";
import CertificatesDocumentsVendorInformationPermissions from "@/utils/json/FieldPermissions/CertificatesDocumentsVendorInformation.json";
import TastingPanelPermissions from "@/utils/json/FieldPermissions/TastingPanel.json";
import NutritionPermission from "@/utils/json/FieldPermissions/Nutrition.json";
import AddNewVendorInformationPermissions from "@/utils/json/FieldPermissions/AddNewVendorUserInformation.json";

import OfficialVendorSetupPermissions from "@/utils/json/FieldPermissions/OfficialVendorSetup.json";

import VendorOnboardingInformationForm from "@/utils/json/FieldPermissions/vendorOnboardingInformationForm.json"

import OfficialProductSetupPermissions from "@/utils/json/FieldPermissions/OfficialProductSetupInformation.json";
import VendorAuditDetailsPermissions from "@/utils/json/FieldPermissions/vendorAuditDetails.json";

import VendorSitesFormInformationPermissions from "@/utils/json/FieldPermissions/VendorSitesFormInformation.json";
import AllergenDeclarationPermissions from "@/utils/json/FieldPermissions/AllergenDeclaration.json";
import AllergenFormPermissions from "@/utils/json/FieldPermissions/AllergenForm.json";
import MainDetailsPermissions from "@/utils/json/FieldPermissions/MainDetails.json";
const { accountServiceAPI } = api;



// Define the structure of the permissions map
const permissionsMap: Record<string, any> = {
  ProductInformation: ProductInformationPermissions.FIELD_PERMISSIONS,
  VendorInformation: VendorInformationPermissions.FIELD_PERMISSIONS,
  VendorAssessment: VendorAssessmentPermissions.FIELD_PERMISSIONS.vendorAssessment,
  IngredientDetails: VendorAssessmentPermissions.FIELD_PERMISSIONS.ingredientsDetails,
  requiredDocuments: VendorAssessmentPermissions.FIELD_PERMISSIONS.requiredDocuments,
  vendorContactInformation: VendorAssessmentPermissions.FIELD_PERMISSIONS.vendorContactInformation,
  vendorNotesForRevisionInformation: VendorAssessmentPermissions.FIELD_PERMISSIONS.notesForRevision,
  manufacturingFacilityInformation: VendorAssessmentPermissions.FIELD_PERMISSIONS.manufacturingFacilityInformation,
  CertificatesDocumentsVendorInformation: CertificatesDocumentsVendorInformationPermissions.FIELD_PERMISSIONS,
  MVADocumentReview: VendorAssessmentPermissions.FIELD_PERMISSIONS.MVADocumentReview,
  GeneralInformation: TastingPanelPermissions.FIELD_PERMISSIONS.generalInformation,
  ResponsibleUsers: TastingPanelPermissions.FIELD_PERMISSIONS.responsibleUsers,
  RetailSalesAndVolume: TastingPanelPermissions.FIELD_PERMISSIONS.retailSalesAndVolume,
  PackageAndBranding: TastingPanelPermissions.FIELD_PERMISSIONS.packageAndBranding,
  CompetitorInformation: TastingPanelPermissions.FIELD_PERMISSIONS.competitorInformation,
  VoteResults: TastingPanelPermissions.FIELD_PERMISSIONS.voteResults,
  Nutrition: NutritionPermission.FIELD_PERMISSIONS,
  AddNewVendorUserInformation: AddNewVendorInformationPermissions.FIELD_PERMISSIONS,
  vendorPrePanelInformation: VendorOnboardingInformationForm.FIELD_PERMISSIONS.vendorPrePanelInformation,
  vendorCompanyInformation: VendorOnboardingInformationForm.FIELD_PERMISSIONS.vendorCompanyInformation,
  vendorAssessmentInformation: VendorOnboardingInformationForm.FIELD_PERMISSIONS.vendorAssessmentDetails,
  // vendorBasicInformation: VendorOnboardingInformationForm.FIELD_PERMISSIONS.vendorBasicInformation,
  foodSafetyQuestionnaire: VendorOnboardingInformationForm.FIELD_PERMISSIONS.foodSafetyQuestionnaire,
  OfficialVendorSetup: OfficialVendorSetupPermissions.FIELD_PERMISSIONS,
  OfficialProductSetupInformation: OfficialProductSetupPermissions.FIELD_PERMISSIONS,
  VendorAuditDetails: VendorAuditDetailsPermissions.FIELD_PERMISSIONS,
  VendorSitesFormInformation: VendorSitesFormInformationPermissions.FIELD_PERMISSIONS,
  vendorSiteDetails: VendorOnboardingInformationForm.FIELD_PERMISSIONS.vendorSiteDetails,
  AllergenDeclaration: AllergenDeclarationPermissions.FIELD_PERMISSIONS,
  AllergenForm: AllergenFormPermissions.FIELD_PERMISSIONS,
  MainDetails: MainDetailsPermissions.FIELD_PERMISSIONS,
};

const AuthService = {
  signOut: async () => {
    try {

      localStorage.removeItem('session');
      localStorage.clear();
      document.cookie = 'token=; Max-Age=0; path=/';
      window.location.href = accountServiceAPI.getUri() + '/signOut';
    } catch (error) {
      console.log(error);
    }

  },

  fetchPermissions: (formName: string): RolePermissions => {
    try {
      const permissions = permissionsMap[formName];
      if (!permissions) {
        console.warn(`No permissions found for form: ${formName}`);
        return {} as RolePermissions;
      }
      return permissions;
    } catch (error) {
      console.error("Error fetching permissions:", error);
      throw error;
    }
  }
};

export default AuthService;